import { render } from "./TargetAudienceSectionPC.vue?vue&type=template&id=64079986&scoped=true"
import script from "./TargetAudienceSectionPC.vue?vue&type=script&lang=js"
export * from "./TargetAudienceSectionPC.vue?vue&type=script&lang=js"

import "./TargetAudienceSectionPC.vue?vue&type=style&index=0&id=64079986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64079986"]])

export default __exports__